import React, {ReactElement, ReactNode, useEffect, useState} from "react";
import {KeyTextStrings} from "../../shared/types";
import {StyledBoxRow, StyledContainer} from "../../shared/StyledComponents";
import {Button} from "@mui/material";
import {PD_LG, PD_SM, PD_XLG} from "../../shared/dimens";

export function AppletTabsContainer({kts, onSelect, children}: {
  kts: KeyTextStrings,
  onSelect: (key: string) => void,
  children: ReactNode,
}): ReactElement {
  const [selectedKey, setSelectedKey] = useState<string>(kts.values[0].key);
  useEffect(() => {
    onSelect(selectedKey);
  }, [selectedKey]);
  return <StyledContainer gutter={true} style={{padding: PD_LG}}>
    <StyledBoxRow style={{marginTop: -PD_LG}}>
      {kts.values.map(value => <Button
        onClick={() => setSelectedKey(value.key)}
        variant={selectedKey === value.key ? "contained" : null}
        style={{fontSize: "120%", padding: `${PD_SM}px ${PD_XLG}px`}}>{value.text}</Button>)}
    </StyledBoxRow>
    {children}
  </StyledContainer>;
}